import React from 'react';
import { UserState } from '../../../../types/UserState';
import { translateUserRole } from '../../../../util';
import StatusBadge from './StatusBadge';
import UnitActionButton from './UnitActionButton';
import { getUserInitials } from './utils';
import {
  UserAvatar,
  UserInfo,
  UserMeta,
  UserName,
  UserRowActions,
  UserRowContainer,
  UserRowMain
} from './styles';

type UserRowProps = {
  user: UserState;
  canManage: boolean;
  isUnassigning: boolean;
  onUnassign: (user: UserState) => void;
};

const UserRow: React.FC<UserRowProps> = ({
  user,
  canManage,
  isUnassigning,
  onUnassign
}) => (
  <UserRowContainer>
    <UserRowMain>
      <UserAvatar aria-hidden>{getUserInitials(user.name || '')}</UserAvatar>

      <UserInfo>
        <UserName>{user.name}</UserName>
        <UserMeta>
          {user.email} · {translateUserRole(user.role)}
        </UserMeta>
      </UserInfo>
    </UserRowMain>

    <UserRowActions>
      <StatusBadge status={user.status} />

      {canManage && (
        <UnitActionButton
          variant="ghost-destructive"
          onClick={() => onUnassign(user)}
          disabled={isUnassigning}
          aria-label={`Desvincular usuário ${user.name}`}
        >
          Remover vínculo
        </UnitActionButton>
      )}
    </UserRowActions>
  </UserRowContainer>
);

export default UserRow;
